
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteO as ObiOwnShipRemoteOElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-o.js';
 
 
 

 
 export const ObiOwnShipRemoteO = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-o',
   elementClass: ObiOwnShipRemoteOElement,
   events: {
     
   }
  });
 
 